var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1180_2967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5431 2.82138C11.7137 2.65081 11.945 2.55499 12.1863 2.55499C12.3057 2.55499 12.424 2.57851 12.5343 2.62422C12.6447 2.66993 12.7449 2.73693 12.8294 2.82138C12.9139 2.90584 12.9808 3.00611 13.0266 3.11646C13.0723 3.22681 13.0958 3.34508 13.0958 3.46452C13.0958 3.58396 13.0723 3.70223 13.0266 3.81258C12.9808 3.92293 12.9139 4.0232 12.8294 4.10765L3.96428 12.9728L2.24925 13.4015L2.67801 11.6865L11.5431 2.82138ZM12.1863 1.32422C11.6186 1.32422 11.0742 1.54971 10.6728 1.9511L1.68719 10.9367C1.60833 11.0156 1.55238 11.1144 1.52532 11.2226L0.806473 14.098C0.754046 14.3078 0.815492 14.5296 0.968341 14.6824C1.12119 14.8353 1.34303 14.8967 1.55274 14.8443L4.42814 14.1255C4.53635 14.0984 4.63517 14.0425 4.71403 13.9636L13.6997 4.97794C13.8984 4.77919 14.0561 4.54325 14.1636 4.28358C14.2712 4.0239 14.3266 3.74559 14.3266 3.46452C14.3266 3.18345 14.2712 2.90513 14.1636 2.64546C14.0561 2.38579 13.8984 2.14984 13.6997 1.9511C13.5009 1.75235 13.265 1.5947 13.0053 1.48714C12.7456 1.37958 12.4673 1.32422 12.1863 1.32422ZM8.78759 13.6315C8.44772 13.6315 8.1722 13.907 8.1722 14.2469C8.1722 14.5868 8.44772 14.8623 8.78759 14.8623H16.1722C16.5121 14.8623 16.7876 14.5868 16.7876 14.2469C16.7876 13.907 16.5121 13.6315 16.1722 13.6315H8.78759Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1180_2967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.788086 0.09375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditConfig);
export default __webpack_public_path__ + "static/media/edit_config.c6087727521e74b8f64440aad30e8d29.svg";
export { ForwardRef as ReactComponent };